<template>
    <ui-modal icon="far fa-cog" name="instructions" title="Instalar em meu Site" size="sm">
        <section class="modal-content-line">
            <h2>1 - Outros Sites</h2>
            <p>Inclua o script abaixo, dentro e ao final da tag body de seu site. O Código deve estar presente em todas as páginas.</p>
            <textarea v-model="scriptComputed" ref="code" class="code-snipets scroll-color notranslate" spellcheck="false"></textarea>
            <br>
            <br>
            <ui-button type="submit" design="md primary center" @click="copyText()"> {{copyBtnText}} </ui-button>
        </section>
        <section class="modal-content-line">
            <h2>2 - Site WordPress</h2>
            <ol class="list-numbers">
                <li>Você poderá instalar o nosso plugin oficial para captura de formulários através do seu <strong>wp-admin</strong>, para isso basta acessar o menu <strong>Plugins > Adicionar Novo</strong>.</li>
                <li>Você pode pesquisar pelo nome do plugin <strong>"Facilita Form Tracker"</strong>, encontrando-o <strong>clique</strong> em <strong>Instalar</strong> e depois <strong>Ativar</strong>.</li>
                <li>Acesse o menu <strong>Configurações > Facilita</strong> Form Tracker e inclua a seguinte url, <strong>https://{{instance}}.facilitavendas.com/</strong> no campo URL.</li>
                <li>Pronto! Basta Preencher seus formulários e <strong>configurá-los</strong> aqui.</li>
            </ol>
        </section>
        <section class="modal-content-line">
            <p>Para maiores informações clique aqui: <a href="https://suporte.appfacilita.com/hc/pt-br" target="_blank">suporte.appfacilita.com</a></p>
        </section>
    </ui-modal>
</template>

<script>

	import { uiButton } from '@/components/ui/buttons'
	import { uiModal } from '@/components/ui/modal'
    
    import { storage } from '@/services/storage'
	
	export default {
		components: { uiButton, uiModal },
		data(){
			return {
                copyBtnText: 'Copiar',
                instance: null,
                script: ''
			}
        },
        computed: {
            scriptComputed: {
                get() {
                    /** Deve-se dividir a string da tag script para que não dê o erro "String literal" */
                    return "<scr" + "ipt type='text/javascript'>(function(){function loadScript(url,callback){var script=document.createElement('script');script.type='text/javascript',script.readyState?script.onreadystatechange=function(){(script.readyState=='loaded'||script.readyState=='complete')&&(script.onreadystatechange=null,callback());}:script.onload=function(){callback();},script.src=url,document.getElementsByTagName('head')[0].appendChild(script);}loadScript('https://cdn.appfacilita.com/static/plugins/jquery.form-tracker.min.js?v=1.5',function(){facilitaFormTrackerFnc({i:'" + this.instance + "'});});}());</scr" + "ipt>"
                }
            }
        },
		methods: {
			copyText(){
				this.$refs.code.select()
				document.execCommand('copy');
				this.copyBtnText = 'Copiado com sucesso!'
				let t = setInterval( () => {
					this.copyBtnText = 'Copiar'
                    clearInterval(t)
                    document.getSelection().removeAllRanges()
				},1000)
            },
            getInstance(){
            }
        },
        created(){
            let api_config = storage.get('api_config');
            api_config = JSON.parse(api_config)
            this.instance = api_config.instance
            
        }
	}
</script>